import { useEffect, useState } from 'react';
import { OperationData } from '../../../types/OperationData';
import { getOperations } from '../../api/api';
import { logger } from '../../../utils/logger';

/**
 * Хук для управления данными операции.
 * 
 * Ответственность:
 * - Загрузка данных операции по ID
 * - Кэширование данных операции
 * - Обработка ошибок загрузки
 * 
 * @param operationId - ID операции для загрузки
 * @returns Данные операции
 */
export function useOperationData(operationId: string | undefined) {
    const [operationData, setOperationData] = useState<OperationData | null>(null);

    useEffect(() => {
        if (operationId) {
            getOperations(operationId)
                .then(data => {
                    setOperationData(data.data || data);
                })
                .catch(error => {
                    logger.error('Ошибка при получении данных операции', { error });
                });
        }
    }, [operationId]);

    return { operationData };
}